<div class="gallery-skeleton">
  <div class="skeleton-topbar">
    <div class="skeleton-avatar shimmer"></div>
    <div class="skeleton-title shimmer"></div>
  </div>

  <div class="skeleton-hero shimmer"></div>

  <div class="skeleton-grid">
    <div class="skeleton-tile shimmer" *ngFor="let tile of tiles"></div>
  </div>

  <p class="skeleton-caption">
    Getting your gallery ready
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </p>
</div>
